import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { faAngleLeft } from '@fortawesome/free-solid-svg-icons';
import { SnapshotProjectListComponent } from '../snapshot-project-list/snapshot-project-list.component';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-snapshot',
    templateUrl: './snapshot.component.html',
    styleUrls: ['./snapshot.component.css'],
    imports: [NgbTooltip, FaIconComponent, SnapshotProjectListComponent]
})
export class SnapshotComponent implements OnInit {

  // Font Awesome Properties
  faAngleLeft = faAngleLeft;

  constructor(public location: Location) { }

  ngOnInit(): void {

  }
}
